import React from "react";
import Table from "../Table";
import moment from "moment";
import { isEmpty } from "lodash-es";
import { useQuery } from "react-query";
import {
  fetchEventSubscriptionsIndex,
  FetchEventSubscriptionsQuery,
} from "../../../../../api/accounts/event_subscriptions";

interface EventSubscriptionsTableProps {
  query: FetchEventSubscriptionsQuery;
}

const EventSubscriptionsTable: React.FC<EventSubscriptionsTableProps> = ({ query }) => {
  const DATE_FORMAT = "MMM DD, YYYY HH:mm";
  const organizationID = query.organization_id;

  const EventSubscriptionIndex = useQuery(
    ["EventSubscriptionIndex", query],
    () => fetchEventSubscriptionsIndex(query),
    { enabled: !isEmpty(query) }
  );

  const getEventSubscriptionsColumns = () => {
    return [
      { title: "Event", dataIndex: "event", key: "event" },
      {
        title: "Platforms",
        dataIndex: "target_platforms",
        key: "target_platforms",
        render: (targetPlatforms: string[]) => targetPlatforms.join(", "),
      },
      {
        title: "Date",
        dataIndex: "created_at",
        key: "created_at",
        render: (date: string) => {
          return moment(date).format(DATE_FORMAT);
        },
      },
    ];
  };

  const title = "Event Subscriptions";
  const fullListLink = `/organizations/${organizationID}/event_subscriptions`;
  const columns = getEventSubscriptionsColumns();

  return (
    <div className="event-subscriptions-table">
      <Table
        headerButtons={[]}
        tableProps={{
          columns,
          dataSource: EventSubscriptionIndex.data ? EventSubscriptionIndex.data.data : [],
          loading: EventSubscriptionIndex.isLoading,
        }}
        title={title}
        fullListLink={fullListLink}
      />
    </div>
  );
};

export default EventSubscriptionsTable;
